// PostCard.js
'use strict';
import { connect } from 'react-redux';

import PostCard from '../component/PostCard.jsx';

import getMessageThumbnail from '../selector/getMessageThumbnail.js';
import getMessageData from '../selector/getMessageData.js';
import getAssetData from '../selector/getAssetData.js';

import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchDrmLicenseAvailability from '../action/fetchDrmLicenseAvailability.js';

const size1x = '512x512';
const size2x = '512x512';

const mapStateToProps = (state, { postId }) => {
  const canViewMedia = getMessageData(state, postId, 'canViewMedia');
  const assetIds = getMessageData(state, postId, 'assetIds');
  const firstAssetContentType = getAssetData(
    state,
    [assetIds?.[0]],
    'contentType'
  );
  const jpg1x = getMessageThumbnail(state, postId, '', size1x, 'jpg', 'clear');
  const jpg2x = getMessageThumbnail(state, postId, '', size2x, 'jpg', 'clear');
  const webp1x = getMessageThumbnail(
    state,
    postId,
    '',
    size1x,
    'webp',
    'clear'
  );
  const webp2x = getMessageThumbnail(
    state,
    postId,
    '',
    size2x,
    'webp',
    'clear'
  );
  return {
    firstAssetContentType,
    jpg1x,
    jpg2x,
    webp1x,
    webp2x,
    canViewMedia,
    assetIds,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMessageDetail: ({ postId }) =>
      dispatch(fetchMessageDetail({ id: postId })),
    fetchDrmLicenseAvailability: ({ messageId, keySystem }) =>
      dispatch(fetchDrmLicenseAvailability({ messageId, keySystem })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostCard);
